import React from 'react';
import { UserButton } from '@clerk/clerk-react';

const GroupardyAuthUserButton = () => {
  return (
    <UserButton/>
  );
};

export default GroupardyAuthUserButton; 